import { useForm } from '@/components/forms';
import { z } from 'zod';
import { useManageReferralValidity } from '../../points-configuration/customerTable/hooks/useManageReferralValidity';
import { ManageReferralValidityView } from './ManageReferralValidityView';

const schema = z.object({
  affiliateToCustomer: z.string().min(1, { message: 'common.form.validation.required' }),
  affiliateToAffiliate: z.string().min(1, { message: 'common.form.validation.required' }),
  customerToCustomer: z.string().min(1, { message: 'common.form.validation.required' }),
});

const options = [
  {
    id: '1',
    label: '1年',
    value: '1',
  },
  {
    id: '2',
    label: '2年',
    value: '2',
  },
  {
    id: '3',
    label: '3年',
    value: '3',
  },
  {
    id: '4',
    label: '4年',
    value: '4',
  },
];
export const ManageReferralValidityContainer = () => {
  const form = useForm({
    schema,
    mode: 'onBlur',
    defaultValues: {
      affiliateToCustomer: '3',
      affiliateToAffiliate: '3',
      customerToCustomer: '3',
    },
  });
  const { mutateAsync } = useManageReferralValidity();

  return (
    <ManageReferralValidityView
      form={form}
      onSubmit={async ({ affiliateToCustomer, affiliateToAffiliate, customerToCustomer }) => {
        await mutateAsync({ affiliateToCustomer, affiliateToAffiliate, customerToCustomer });
      }}
      options={options}
    />
  );
};
